import AbstractPage from 'page/AbstractPage';
import ProductListViewMode from 'component/ProductListViewMode';
import tools from "../tools";

export default class SearchPage extends AbstractPage {
    constructor() {
        super();

        this.viewMode = new ProductListViewMode;
        this.$filterForm = $('.search-filter');
        this.$resultPopup = this.$filterForm.find('.product-filter-result-popup');
        this.$parent = $('.search-page__content');
        this.initFilter();
    }

    initFilter() {
        this.$filterForm.find('input[type="checkbox"]').on('change', this.onFilterCheckboxChange.bind(this));
        this.$filterForm.find('input[type="text"]').on('input', this.onFilterInputChange.bind(this));
        this.$filterForm.find('.product-filter-param__title').on('click', this.toggleOptionsList.bind(this));
        this.$parent.find('.section-filter__item').on('click', this.onSectionClick.bind(this));
    }

    toggleOptionsList(e) {
        const $param = $(e.currentTarget).closest('.product-filter-param');
        $param.toggleClass('.product-filter-param--collapsed').toggleClass('product-filter-param--expanded');

        $param.find('.product-filter-param__options-wrapper').slideToggle();
    }

    onSectionClick(e) {
        e.preventDefault();
        const sectionId = e.currentTarget.getAttribute('data-id');
        this.$filterForm.find("input[name=\"section_id\"]").val(sectionId);
        window.location.href = '/search/?' + this.$filterForm.serialize();
    }

    onFilterCheckboxChange(e) {
        this.$lastChangedItemWrapper = $(e.currentTarget).closest('.product-filter-param__option');

        if (this.$lastChangedItemWrapper.length == 0) {
            this.$lastChangedItemWrapper = $(e.currentTarget).closest('.product-availability-filter__option');
        }

        this.updateFacetWithDelay(50);
    }

    onFilterInputChange(e) {
        this.$lastChangedItemWrapper = $(e.currentTarget).closest('.product-filter-param__options-wrapper');

        this.updateFacetWithDelay(300);
    }

    updateFacetWithDelay(delay) {
        clearTimeout(this.updateTimeout);
        this.updateTimeout = setTimeout(this.updateFacet.bind(this), delay);
    }

    updateFacet() {
        this.hideResultPopup();

        let formData = this.$filterForm.serializeArray();
        formData.push({name: 'method', value: 'facet'});
        formData.push({name: 'ajax', value: 'Y'});
        formData.push({name: 'sessid', value: app.sessid});

        $.ajax({
            url: '/search/',
            method: 'get',
            data: formData,
            dataType: 'json',
        }).done((response) => {
            if (response.status == 'error') {
                console.error(response);
                return;
            }

            for (let filterItem of Object.values(response.filterItems)) {
                if (filterItem.price) {
                    for (let [valueKey, valueItem] of Object.entries(filterItem.values)) {
                        let inputSelector = `[name="${valueItem['controlName']}"]`;
                        let label = valueKey === 'min' ? 'От' : 'До';
                        this.$filterForm.find(inputSelector).attr('placeholder', label + ' ' + valueItem.value);
                    }
                } else {
                    for (let valueItem of Object.values(filterItem.values)) {
                        let inputSelector = `[name="${filterItem['controlName']}${ filterItem.multiple ? '\[\]' : '' }"][value="${valueItem.id}"]`;
                        this.$filterForm.find(inputSelector).prop('disabled', valueItem.disabled === true);
                    }
                }
            }

            if (response.productsCount !== undefined) {
                this.showResultPopup(response.productsCount, '/search/?' + this.$filterForm.serialize());
            }
        });
    }

    /**
     * Show result popup under last changed param option
     * @param {number} count
     * @param {string} applyUrl
     */
    showResultPopup(count, applyUrl) {
        this.$resultPopup.find('.product-filter-result-popup__apply').attr('href', applyUrl);

        let text = tools.plural(parseInt(count, 10), 'Найден #count# товар', 'Найдено #count# товара', 'Найдено #count# товаров');
        this.$resultPopup.find('[data-var="text"]').text(text.replace('#count#', count));

        this.$lastChangedItemWrapper.after(this.$resultPopup);
        this.$resultPopup.toggleClass('hidden', false);

        clearTimeout(this.hidePopupTimeout);
        this.hidePopupTimeout = setTimeout(this.hideResultPopup.bind(this), 2500);
    }

    hideResultPopup() {
        clearTimeout(this.hidePopupTimeout);
        this.$resultPopup.toggleClass('hidden', true);
    }
}

$(function () { app.pageController = new SearchPage(); });
